var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('guide-list',{attrs:{"crag":_vm.crag}}),_vm._v(" "),_c('client-only',[(_vm.$auth.loggedIn)?_c('div',{staticClass:"mt-3"},[_c('add-guide-book-btn',{attrs:{"crag":_vm.crag}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }